module.exports = __webpack_public_path__ + "73d52d2450300f856212b45d6775cd9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GroupMembersTabList/participants.svg
// module id = 2567
// module chunks = 0 1